module.exports = __webpack_public_path__ + "img/pauli-x-root-dagger-0.69bd987a.svg";